import {
  apiClient,
  ApiClientConfig,
  PaginatedRequestParams,
  PaginatedResponse,
} from 'api';
import { User } from 'types';
type userMenu = {
  id: string;
  menu: string;
  isPermission: boolean;
}
export interface GetUserListResponse extends User {
  "Menu": userMenu[]
}

interface BaseResponse<T> {
  rs: number;
  res?: T;
  rc?: any[]; // if this is always an array, or refine as needed
  msgkey?: string | null;
  ukey?: string;
  customMessage?: string;
  itemId?: number;
  totalRecords?: number;
}
export type SupplierResponse = BaseResponse<PaginatedResponse<User>>;

export const ReportApiService = () => {
  const getReportViewList = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<SupplierResponse>({
      ...callConfig,
      endpoint: `AdminWeighbridge/VisitReport`,
      params,
    });

    return response.data;
  };
  const getReportCommonList = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<SupplierResponse>({
      ...callConfig,
      endpoint: `EntryGate/GetCommonMasterList`,
      params,
    });

    return response.data;
  };
  const getReportTableData = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<SupplierResponse>({
      ...callConfig,
      endpoint: `AdminWeighbridge/VisitReportTableData`,
      params,
    });

    return response.data;
  };

const getDownloadReportTableData = async (
  params: Record<string, any>,
  fileName = "report.csv",
) => {
  try {
    const response = await apiClient<Blob>({
      endpoint: "/AdminWeighbridge/DownloadVisitReportTableData",
      method: "GET",
      params,
      responseType: "blob",
    }as any);

    const blob = new Blob([response.data], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Failed to download CSV report:", error);
  }
};


  return {
    getReportViewList,
    getReportCommonList,
    getReportTableData,
    getDownloadReportTableData
  };
};
